import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Doctors from "@/pages/Doctors";
import DoctorProfile from "@/pages/DoctorProfile";
import Booking from "@/pages/Booking";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PatientDashboard from "@/pages/PatientDashboard";
import DoctorDashboard from "@/pages/DoctorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Specialties from "@/pages/Specialties";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex min-h-screen items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Shell({ children, bare = false }) {
  if (bare) return <>{children}</>;
  return (
    <>
      <Header />
      <main className="min-h-[70vh]">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/doctors" element={<Shell><Doctors /></Shell>} />
          <Route path="/doctor/:id" element={<Shell><DoctorProfile /></Shell>} />
          <Route path="/specialties" element={<Shell><Specialties /></Shell>} />
          <Route path="/about" element={<Shell><About /></Shell>} />
          <Route path="/contact" element={<Shell><Contact /></Shell>} />
          <Route path="/login" element={<Shell><Login /></Shell>} />
          <Route path="/register" element={<Shell><Register /></Shell>} />
          <Route path="/book/:id" element={<Shell><Protected roles={["patient"]}><Booking /></Protected></Shell>} />
          <Route path="/patient/dashboard" element={<Shell><Protected roles={["patient"]}><PatientDashboard /></Protected></Shell>} />
          <Route path="/doctor/dashboard" element={<Shell><Protected roles={["doctor"]}><DoctorDashboard /></Protected></Shell>} />
          <Route path="/admin" element={<Shell><Protected roles={["admin"]}><AdminDashboard /></Protected></Shell>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
